import { render } from "./PrivacyView.vue?vue&type=template&id=05225f6d&scoped=true"
import script from "./PrivacyView.vue?vue&type=script&lang=js"
export * from "./PrivacyView.vue?vue&type=script&lang=js"

import "./PrivacyView.vue?vue&type=style&index=0&id=05225f6d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05225f6d"]])

export default __exports__